export function transitYBIValidate(res){
    var result = true;

    result = validateOjects(res.data);

    return result;
}

function validateOjects(data) {
    return (typeof data === 'object'
        && Array.isArray(data.states)
        && typeof data.totals === 'object'
    )
}